export const AUTH = {
	REMEMBERME: "rememberMe",
	TRUE: "true",
	FALSE: "false"
};